import { Box, Text } from "@chakra-ui/react";
import { DateTime } from "luxon";

type Props = {
  accountHolder: string;
  accountId: string;
  correspondentCode: string;
  noteData?: any;
};
const AuxHeader = ({ accountHolder, accountId, correspondentCode }: Props) => {
  const asOfTime = DateTime.now().toFormat("MM/dd/yyyy hh:mm:ss ZZZZ");
  return (
    <Box>
      <Text as="h2">
        {accountHolder} — {accountId} ({correspondentCode})
      </Text>
      <Text as="h2">As of {asOfTime}</Text>
    </Box>
  );
};

export default AuxHeader;
